require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./commercial-demonstration-in-portland-oregon.json") })
        }
      }, "path---commercial-demonstration-in-portland-oregon");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---commercial-demonstration-in-portland-oregon!./.cache/json/commercial-demonstration-in-portland-oregon.json
// module id = 859
// module chunks = 231608221292675